import * as yup from 'yup';

import { AddressFieldsFormFields } from 'src/constants/address';
import {
  ERROR_MESSAGE_REQUIRED_ZIP_CODE,
  emailValidationSchema,
  numberOfEmployeesSimpleValidationSchema,
  phoneNumberValidationSchema,
  taxYearEndDateSimpleValidationSchema,
  zipCodeValidationSchema,
} from 'src/constants/validation';
import { REQUIRED_VALIDATION_MESSAGE } from 'src/constants/validationMessage';

import { CompanyInformationFormPeoPayrollProviderFields } from '../types';

export const companyInformationFormPeoPayrollProviderValidationSchema = yup.object({
  [CompanyInformationFormPeoPayrollProviderFields.displayName]: yup
    .string()
    .nullable()
    .required(REQUIRED_VALIDATION_MESSAGE),
  [CompanyInformationFormPeoPayrollProviderFields.contactEmail]: emailValidationSchema
    .nullable()
    .required(REQUIRED_VALIDATION_MESSAGE),
  [CompanyInformationFormPeoPayrollProviderFields.contactPhoneNumber]: phoneNumberValidationSchema,
  [CompanyInformationFormPeoPayrollProviderFields.industry]: yup.string().nullable(),
  [CompanyInformationFormPeoPayrollProviderFields.corporateStructure]: yup.string().nullable(),
  [CompanyInformationFormPeoPayrollProviderFields.numberOfEmployees]:
    numberOfEmployeesSimpleValidationSchema,
  [CompanyInformationFormPeoPayrollProviderFields.taxYearEndDate]:
    taxYearEndDateSimpleValidationSchema,
  [CompanyInformationFormPeoPayrollProviderFields.defaultDisclaimer]: yup.string().nullable(),
  [CompanyInformationFormPeoPayrollProviderFields.headquarters]: yup.object({
    [AddressFieldsFormFields.street]: yup.string().required('Required street'),
    [AddressFieldsFormFields.city]: yup.string().required('Required city'),
    [AddressFieldsFormFields.county]: yup.string().nullable(),
    [AddressFieldsFormFields.state]: yup.string().required('Required state'),
    [AddressFieldsFormFields.zipCode]: zipCodeValidationSchema.required(
      ERROR_MESSAGE_REQUIRED_ZIP_CODE,
    ),
  }),
  [CompanyInformationFormPeoPayrollProviderFields.fein]: yup
    .string()
    .nullable()
    .test('invalid-fein', 'Invalid FEIN', value => !Number.isNaN(Number(value)))
    .length(9, 'Invalid FEIN')
    .required('Required'),
});
